export default "__VITE_ASSET__Did5u8Sb__"